import { Injectable } from '@angular/core';
import { EnvioEmail } from '../app.domain.models/envio-email';
import { EnvioEmailRepository } from '../app.domain.repository/envio-email.repository';
import { GenericEntityService } from '../core.utilidades/generic-entity.service';

@Injectable({
    providedIn: 'root',
})
export class EnvioEmailApiService extends EnvioEmailRepository implements GenericEntityService<EnvioEmail> { }
